import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function Login() {
  const { login, formatApiError } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(email, password);
      nav("/dashboard");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex">
      <div className="hidden lg:flex flex-1 relative grid-bg border-r border-white/10">
        <div className="absolute inset-0 bg-gradient-to-br from-transparent via-transparent to-[#007AFF]/5" />
        <div className="relative z-10 p-12 flex flex-col justify-between">
          <div>
            <div className="flex items-center gap-3 mb-2">
              <div className="w-9 h-9 bg-[#007AFF] flex items-center justify-center text-white font-display font-bold">
                T
              </div>
              <div className="font-display text-2xl font-bold tracking-tight">TIPPADÓ</div>
            </div>
            <div className="text-[10px] tracking-[0.3em] text-zinc-500 uppercase">Pro Terminal · 2026</div>
          </div>
          <div>
            <h1 className="font-display text-5xl font-bold leading-[0.95] tracking-tight mb-6 max-w-md">
              ADATVEZÉRELT
              <br />
              <span className="text-[#007AFF]">FOGADÁSI</span>
              <br />
              ELEMZÉS
            </h1>
            <p className="text-zinc-400 max-w-md leading-relaxed">
              Poisson-modell és valós idejű piaci adatok. Napi mérkőzések, súlyozott valószínűségek,
              automatikus szelvénygenerálás.
            </p>
            <div className="mt-10 grid grid-cols-3 gap-px bg-white/10 max-w-md">
              <div className="bg-[#0A0A0A] p-4">
                <div className="text-2xl font-display font-bold text-[#22C55E]">95%+</div>
                <div className="text-[10px] tracking-wider text-zinc-500 uppercase mt-1">Lefedettség</div>
              </div>
              <div className="bg-[#0A0A0A] p-4">
                <div className="text-2xl font-display font-bold">0 Ft</div>
                <div className="text-[10px] tracking-wider text-zinc-500 uppercase mt-1">Havidíj</div>
              </div>
              <div className="bg-[#0A0A0A] p-4">
                <div className="text-2xl font-display font-bold text-[#007AFF]">5+</div>
                <div className="text-[10px] tracking-wider text-zinc-500 uppercase mt-1">Piac típus</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-8">
        <form onSubmit={onSubmit} className="w-full max-w-sm" data-testid="login-form">
          <h2 className="font-display text-3xl font-bold mb-1 tracking-tight">Bejelentkezés</h2>
          <p className="text-sm text-zinc-400 mb-8">Lépj be a fiókodba a folytatáshoz</p>

          <div className="space-y-5">
            <div>
              <Label htmlFor="email" className="text-xs uppercase tracking-wider text-zinc-400">
                E-mail cím
              </Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="login-email-input"
                className="mt-1.5 bg-[#141414] border-white/10 focus-visible:ring-[#007AFF] focus-visible:ring-2"
                placeholder="te@email.hu"
              />
            </div>
            <div>
              <Label htmlFor="password" className="text-xs uppercase tracking-wider text-zinc-400">
                Jelszó
              </Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="login-password-input"
                className="mt-1.5 bg-[#141414] border-white/10 focus-visible:ring-[#007AFF] focus-visible:ring-2"
                placeholder="••••••••"
              />
            </div>

            {error && (
              <div data-testid="login-error" className="text-sm text-[#EF4444] bg-[#EF4444]/10 border border-[#EF4444]/30 px-3 py-2">
                {error}
              </div>
            )}

            <Button
              type="submit"
              disabled={submitting}
              data-testid="login-submit-btn"
              className="w-full bg-[#007AFF] hover:bg-[#3395FF] text-white font-medium tracking-tight h-11"
            >
              {submitting ? "Bejelentkezés..." : "Bejelentkezés"}
            </Button>
          </div>

          <div className="mt-6 text-sm text-zinc-400 text-center">
            Nincs még fiókod?{" "}
            <Link to="/register" data-testid="goto-register-link" className="text-[#007AFF] hover:underline">
              Regisztráció
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
